import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, of, switchMap } from 'rxjs';
import { TICKET_REPOSITORY } from '../../domain/tokens/ticket.token';
import { Ticket } from '../../domain/model/ticket.model';

@Injectable({ providedIn: 'root'})
export class GetLastTicketUseCase {
  private readonly ticketRepository = inject(TICKET_REPOSITORY);
  private readonly destroyRef = inject(DestroyRef);

  execute(ticketId: string): Observable<Ticket | null> {
    return this.ticketRepository.getLastTicket().pipe(
      switchMap((lastTicket) => {
        if (lastTicket && lastTicket.id === ticketId) {
          return of(lastTicket);
        }

        return of(null);
      }),
      takeUntilDestroyed(this.destroyRef)
    );
  }
}
